/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import Loading from '../../Shared/Loading'
import { Tabs, Tab } from 'react-bootstrap'
import { history } from '../../../_helpers'
import { unitTasksService } from '../../../_services/unitTasks.service'
import { taskOperationsService } from '../../../_services/taskOperations.service'
import ConfirmDialog from '../../Shared/ConfirmDialog'
import { FaAngleLeft } from 'react-icons/fa'
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import { MdPrint } from 'react-icons/md'

import { Formik, FieldArray, Field } from 'formik'
import * as Yup from 'yup'

import Step1 from './Step1'
import Step2 from './Step2'
import Step3 from './Step3'
import Step5 from './Step5'
import { TaskStartPrint } from './TaskStartPrint'

import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai";

class StartTaskForm extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      confirmDialogShow: false,
      loading: false,
      key: 'info',
      isModal: this.props.isModal,
      id: this.props.isModal ? this.props.id : this.props.match.params.id,
      taskType: this.props.isModal ? this.props.taskType : this.props.match.params.taskType,
      unitId: this.props.unitId ? this.props.unitId : this.props.match.params.unitId,
      data: {
        unitId: '',
        taskId: '',
        description: '',
        items: [
          { categoryId: '', brandId: '', productId: '', quantity: 0 }
        ]
      }
    }


  }

  componentDidMount() {
    console.log(this.props.unitId);

    this.getData()
  }

  getData = async () => {

    const { id } = this.state;

    if (id) {

      this.setState({ loading: true });

      await unitTasksService.getByIdSCum(id)
        .then((res) => {
          let data = res.data;

          data["lastDescription"] = data.description;
          data["description"] = '';

          if (data.items && data.items.length>0) {

            let outputs = []
            data.items.forEach(item => {
              item["extraQuantity"] = 0;
              item["subExtraQuantity"] = 0;
              item["firstQuantity"] = item.quantity;
              item["firstSubQuantity"] = item.subQuantity;
              if (item.taskOperationProductType === 1) {
                outputs.push(item)
              }
            });

            data["items"] = data.items.filter(el => parseInt(el.taskOperationProductType, 0) === 0);
            data["outputs"] = outputs;

          }

          data["unitId"] = this.state.unitId;

          console.log(data);
          this.setState({ data: data, loading: false })

        })
        .catch((error) => {

          // console.log(error);

          this.setState({ loading: false });

        });

    }


  };

  handleSubmit = (values, setSubmitting) => {
    // this.setState({ loading: true });
    console.log("here");

    let dto = {};
    dto["unitId"] = this.state.unitId;
    dto["taskId"] = this.state.data.taskId;
    dto["PreviousUnitTaskId"] = this.state.data.id;

    console.log((dto));

    this.setState({ finalDto: dto }, () => {
      this.handleShowConfirmDialog(true)
    })



  }

  handleShowConfirmDialog = (val) => {
    this.setState({ confirmDialogShow: val })
  }

  handleSubmitAfterConfirm = () => {

    this.handleShowConfirmDialog(false)

    this.setState({ startTaskLoading: true });

    taskOperationsService.scumStartTaskOperation(JSON.stringify(this.state.finalDto))
      .then((res) => {
        console.log(res);

        this.setState({ loading: false, startTaskLoading: false, taskSemiFinishedLoading: false });
        toastr.success('ثبت اطلاعات انجام شد');

        this.props.onSubmit()

      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false, startTaskLoading: false, taskSemiFinishedLoading: false });
      });

  }

  handlePrint = id => {

    this.setState({ idForPrint: id, showPrintDialog: true })

  }

  render() {
    const { data, startTaskLoading } = this.state;
    const itemsCount = data.items.length;

    const item = Yup.object().shape({
      waste: Yup.number().nullable().min(0, 'مقدار ضایعات').required('مقدار ضایعات'),
      // productId: Yup.string().trim().nullable().required('محصول')
    });

    const ValidationSchema = Yup.object().shape({
      unitId: Yup.string().trim().nullable().required('واحد'),
      // quantity: Yup.string().trim().nullable().required('تعداد ورق پرس شده سالم'),
      // waste: Yup.string().trim().nullable().required('تعداد ضایعات'),
      // items: Yup.array().of(item).min(itemsCount, 'تمامی اطلاعات').required('تمامی اطلاعات محصول'),
    });
    return (
      <Formik
        enableReinitialize
        initialValues={data}
        onSubmit={(values, { setSubmitting }) => {
          // setSubmitting(true);
          this.handleSubmit(values);
          setSubmitting(false);
        }}
        validationSchema={ValidationSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            validateForm,
          } = props;
          return (
            <div>
              <div className="row" style={{ position: "relative" }}>
                <Fab color="secondary" aria-label="refresh" size="small" onClick={() => this.props.onClose()} className="modal-close-btn absolute">
                  <MdClose size="20px" />
                </Fab>
                <form onSubmit={handleSubmit} id="form">

                  {/* <Tabs transition={false}
                    id="controlled-tab-example"
                    activeKey={this.state.key}
                    onSelect={key => this.setState({ key })}
                  >

                    <Tab eventKey="info" title="اطلاعات فرآیند تولید"> */}
                  <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                      <Step1 {...props} taskType={this.state.taskType} />
                      <Step5 {...props} taskType={this.state.taskType} />
                      <Step2 {...props} taskType={this.state.taskType} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-10 col-lg-offset-1">
                      <div className="row">
                        <div className="col-md-12 col-xs-12">
                          <button type="submit" className={"btn btn-info btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                            disabled={startTaskLoading}
                            onClick={e => {
                              e.preventDefault();
                              this.setState({ taskFinished: false, dialogTitle: "تایید شروع انجام سفارش", dialogText: "آیا تمامی مواد اولیه مندرج در لیست را از انبار تحویل گرفته اید و میخواهید انجام سفارش را شروع کنید؟" }, () => {
                                // $(this).closest('form').submit()
                                handleSubmit();
                              })
                            }}
                          >
                            {startTaskLoading ?
                              <AiOutlineLoading className="mdi-spin" size="22px" />
                              :
                              'تمامی اقلام مواد اولیه لیست بالا از انبار دریافت شد و این سفارش از این لحظه ' + (data && data.unit ? 'در [ ' + data.unit.name + ' ]' : '') + ' در حال انجام می باشد.'
                            }
                          </button>
                        </div>
                        <div className="clearfix"></div>
                        <div className="clearfix"></div>
                        <div className="col-md-6">
                          <button className={"btn btn-danger btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                            disabled={startTaskLoading}
                            onClick={e => {
                              e.preventDefault();
                              this.handlePrint(values.id);
                            }}
                          >
                            <MdPrint size="24px" style={{ verticalAlign: 'middle', marginLeft: 5 }} />
                            چاپ
                          </button>
                        </div>
                        <div className="col-md-6">
                          <button className={"btn btn-default btn-block btn-ripple btn-font-lg" + (isSubmitting ? "isSubmitting" : "")}
                            disabled={startTaskLoading}
                            onClick={e => {
                              e.preventDefault();
                              this.props.onClose();
                            }}
                          >
                            بازگشت
                          <FaAngleLeft style={{ verticalAlign: 'middle', marginRight: 5 }} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

<TaskStartPrint
  id={this.state.idForPrint}
  show={this.state.showPrintDialog}
  onClose={() => this.setState({ showPrintDialog: false })}
/>

                  {/* </Tab>
                    <Tab eventKey="materialsTab" title="مواد اولیه"> */}



                  {/* </Tab>

                  </Tabs> */}
                  {/* {JSON.stringify(values)} */}
                </form>
              </div>
              <ConfirmDialog open={this.state.confirmDialogShow}
                onClose={() => this.handleShowConfirmDialog(false)}
                onConfirm={() => this.handleSubmitAfterConfirm()}
                title={this.state.dialogTitle}
                text={this.state.dialogText}
              />
              {this.state.loading ? <Loading /> : ''}
            </div>
          );
        }}
      </Formik>
    );
  }
}

export default StartTaskForm;
